<template>

    <div class="w-100">
        <div class="d-flex flex-wrap border-bottom w-100">

            <div v-for="appTable in model.app.tables" class="py-1 px-3 tab-div"
                 :key="appTable.id + 'Tab'"
                 :class="table.id === appTable.id ? activeClasses : inActiveClasses">
                <a v-if="table.id === appTable.id" href="javascript:void(0)" class="text-primary no-underline">{{table.name}}</a>

                <router-link v-else :to="{ name: 'view-renderer', params: {id: appTable.views[0].id}}" class="text-dark no-underline">
                    {{appTable.name}}
                </router-link>
            </div>

            <div @click="onNewTableClick()" class="mt-1 px-2 pointer text-primary border-bottom tab-div">
                <i class="fad fa-plus-circle"></i>
            </div>

            <table-modal key="newTableModal" v-if="showTableModal" :table="newTable"
                         @noEvent="showTableModal = false"
                         :yesEvent="onTableCreated"></table-modal>

        </div>

    </div>
</template>

<script>

    import TableModal from "../../components/TableModal.vue";

    export default {
        name: 'TabNavigator',
        components: {TableModal},
        props: ['table'],
        computed: {
            activeClasses() {
                return "border active-tab rounded-top"
            },
            inActiveClasses() {
                return "border-bottom"
            }
        },
        data() {
            return {
                model: webase.model,
                showTableModal: false,
                newTable: {
                    id: null,
                    name: '',
                    description: '',
                    app_id: webase.model.app.id
                },
                onTableCreated: function (table) {
                }
            }
        },
        methods: {

            onNewTableClick() {
                this.newTable = {
                    id: null,
                    name: '',
                    description: '',
                    app_id: webase.model.app.id
                }
                this.showTableModal = true

                this.onTableCreated = (table) => {
                    console.log('Table created callback')
                    let view = table.views[0]
                    this.$router.push({ name: 'view-renderer', params: {id: view.id}})
                }
            }
        }
    }
</script>
